import React, { useEffect } from "react";
import TimeIcon from "assets/svgIcons/AdminDashboard/TodayRoundsIcon";
import RidingIcon from "assets/svgIcons/AdminDashboard/RidingIcon";
import { useHookstate } from "@hookstate/core";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import {
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { API_STATUSES } from "redux/_helpers/statuses";

const TodaysRound = () => {
  const { t } = useTranslation();

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const dispatch = useDispatch();
  const {
    getDashboardRidingCarState,
    siteSettingsData,
    getDashboardFeatureSetStatus,
  } = useSelector((state) => state?.commonReducers) || [];

  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteId.get() !== null &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0
    ) {
      const theCurrQueryDate = moment(new Date())
        .utc()
        .utcOffset(-siteSettingsData?.TimeZoneOffset)
        .format("YYYY-MM-DD");

      dispatch(
        COMMON_SERVICES.getDashboardRidingByCarServices(
          siteId.get(),
          localStorage.getItem("dashCourseId"),
          theCurrQueryDate
        )
      );
    }
  }, [
    getDashboardFeatureSetStatus,
    siteId.get(),
    localStorage.getItem("dashCourseId"),
    siteSettingsData,
  ]);

  return (
    <>
      <div className="header">
        <TimeIcon />
        <p className="green-border">{t("Todays_Rounds")}</p>
      </div>
      <div className="box-body today-rounds-section">
        <div>
          <RidingIcon />
          <h2 className="bp-heading">
            {getDashboardRidingCarState?.TodayRidingCount}
          </h2>
        </div>
      </div>
    </>
  );
};

export default TodaysRound;
